// Hidden SEO content component - visible to crawlers but hidden from users
// Uses sr-only (screen reader only) CSS class for accessibility-friendly hiding

export function SEOHiddenContent() {
  return (
    <div 
      className="sr-only" 
      aria-hidden="true"
      style={{ 
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0
      }}
    >
      {/* Primary Keywords */}
      <h1>Office Furniture Store India - Buy Office Workstation Online | Office Furniture Online</h1>
      
      <article>
        <h2>Office Furniture Store India - Premium Modular Solutions for Modern Workspaces</h2>
        <p>
          Welcome to India's leading <strong>office furniture store India</strong>. Buy office furniture online including modular workstations, 
          office phone booths, workstation desks, and modular office cubicles. Our <strong>office furniture online</strong> collection features 
          premium sliding door cabinets, phone pods, under desk storage, and modular office partitions. <strong>Buy office workstation</strong> from 
          India's most trusted office furniture store.
        </p>
        
        <h2>Buy Office Workstation - Modern Office Workstations Online India</h2>
        <p>
          <strong>Buy office workstation</strong> from our extensive collection. Shop modular workstations and modern office workstations at the best workstation desk price. 
          Our <strong>office furniture online</strong> store offers ready modular workstation and readymade modular workstation options perfect for workstations for office spaces. 
          As the leading <strong>office furniture store India</strong>, we offer the best modern workstations for corporate environments.
        </p>
        
        <h2>Office Furniture Online - Phone Booths & Privacy Pods</h2>
        <p>
          Buy privacy booth and office privacy pods for focused work. Our soundproof office meeting pods and phone booths for office 
          provide acoustic isolation. <strong>Office furniture online</strong> shopping made easy - buy phone booth online or choose from our ready phone booth for office options. 
          Shop meeting pods, buy soundproof booths at India's best <strong>office furniture store</strong>.
        </p>
        
        <h2>Office Furniture Store - Storage Solutions & Cabinets</h2>
        <p>
          Buy office storage with our comprehensive office storage solutions. Shop office storage cabinets, office cabinets, 
          and modular office storage systems. Buy office cabinet with drawers from our office storage cabinets with drawers range. 
          Our office credenzas, buy filing cabinets, and buy office shelving options provide complete storage solutions.
        </p>
        
        <h2>Focus Pods & Acoustic Booths - Order Office Pods Online</h2>
        <p>
          Order office pods including focus pods and shop acoustic pods for quiet workspaces. Our office pods collection features 
          premium soundproof booths and acoustic solutions. Order modular cubicles for open office environments.
        </p>
        
        <h2>Buy Readymade Office Furniture - Ready to Deliver</h2>
        <p>
          Buy readymade office furniture that's ready to deliver. Our ecommerce modular furniture platform makes it easy to 
          buy office furniture online. Visit our office furniture store or browse our office furniture shops online. 
          We offer office solutions furniture for businesses across India with ready to deliver office furniture options.
        </p>
      </article>
      
      {/* Keyword-rich lists for search engines */}
      <nav>
        <h3>Our Products</h3>
        <ul>
          <li>Office Furniture</li>
          <li>Office Workstations</li>
          <li>Modular Workstations</li>
          <li>Office Phone Booths</li>
          <li>Workstation Desks</li>
          <li>Modular Office Cubicles</li>
          <li>Sliding Door Cabinets</li>
          <li>Phone Pods</li>
          <li>Under Desk Storage</li>
          <li>Modular Office Partitions</li>
          <li>Office Credenzas</li>
          <li>Focus Pods</li>
          <li>Privacy Booths</li>
          <li>Meeting Pods</li>
          <li>Filing Cabinets</li>
          <li>Soundproof Booths</li>
          <li>Acoustic Pods</li>
          <li>Office Shelving</li>
        </ul>
      </nav>
      
      <section>
        <h3>Buy Office Furniture Online</h3>
        <ul>
          <li>Buy Privacy Booth</li>
          <li>Shop Modular Workstations</li>
          <li>Order Office Pods</li>
          <li>Buy Office Storage</li>
          <li>Workstation Desk Price</li>
          <li>Shop Meeting Pods</li>
          <li>Buy Filing Cabinets</li>
          <li>Office Booth Sale</li>
          <li>Purchase Workstations</li>
          <li>Buy Soundproof Booths</li>
          <li>Order Modular Cubicles</li>
          <li>Shop Acoustic Pods</li>
          <li>Buy Office Shelving</li>
          <li>Privacy Booth Cost</li>
        </ul>
      </section>
      
      <section>
        <h3>Ecommerce Modular Furniture</h3>
        <p>
          Buy office privacy pod, buy office workstation, buy ready modular workstation, buy readymade modular workstation, 
          buy modular workstation online, buy office cabinet, soundproof office meeting pods, buy readymade office furniture, 
          buy office furniture online, buy phone booth online, buy ready phone booth for office.
        </p>
      </section>
      
      <section>
        <h3>Office Furniture Store - Office Solutions</h3>
        <p>
          Office Privacy Pods, Office Storage Solutions, Modular Workstation, Readymade Office Furniture, 
          Ready to Deliver Office Furniture, office furniture store, workstations for office, office storage cabinets, 
          office cabinets, office solutions furniture, modular office workstations, modular office storage, 
          office storage cabinets with drawers, modern workstations, office furniture shops, 
          office furniture modular workstations, modern office workstations, buy office furniture online.
        </p>
      </section>
      
      {/* Local SEO */}
      <address>
        <h3>Modular Furniture Store - Office Furniture Mumbai</h3>
        <p>
          A-611, Crystal Plaza Premises, New Link Road, Andheri (W), Mumbai 400053, Maharashtra, India.
          Phone: +91 9594685818, +91 9820042100.
          Email: hello@modularfurniturestore.com
        </p>
        <p>
          Best office furniture store in Mumbai. Buy office furniture in Mumbai, Navi Mumbai, Thane, Pune, and Pan India. 
          Office furniture delivery available across India.
        </p>
      </address>
    </div>
  );
}
